<template>
  <div :class="['campaign-form-container', { 'mt-0 pt-0 pb-2': source && source.includes('update'), 'py-2': !source }]">
    <h3 class="form-title" v-if="!source">Design</h3>
    <div class="design-container mt-4 d-flex position-relative">
      <div class="design-wrapper flex-grow-1 flex-shrink-0">
        <Stamps ref="StampsForm" :source="source" />
        <Rewards ref="RewardsForm" :source="source" />
        <Customize ref="CustomizeForm" :source="source" />
      </div>
      <div class="design-preview text-center flex-shrink-0">
        <PunchCardPreview />
        <p class="preview-label mt-2">Preview</p>
        <p>For illustrative purposes only. Your real stampcard may appear slightly different on the app.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Stamps from "./design/Stamps.vue";
import Rewards from "./design/Rewards.vue";
import Customize from "./design/Customize.vue";
import PunchCardPreview from "./design/PunchCardPreview.vue";

export default {
  props: ["source"],
  components: { Stamps, Rewards, Customize, PunchCardPreview },
  mounted() {
    this.$root.$on("validateForm", async () => {
      const { StampsForm, RewardsForm, CustomizeForm } = this.$refs;

      if (!StampsForm.$v.$invalid && !RewardsForm.$v.$invalid && !CustomizeForm.$v.$invalid) {
        this.$root.$emit("createCampaign");
      };
    });

    this.evaluateDesignPreviewPosition();

    window.addEventListener("scroll", () => this.evaluateDesignPreviewPosition());

    window.addEventListener("resize", () => this.evaluateDesignPreviewPosition());

    this.$root.$on("evaluateDesignPreviewPosition", () => {
      const campaignUpdate = document.querySelector("#punch-card-campaign-update-container > .update-form-container");

      document.querySelector(".design-preview").style.opacity = 0;

      this.evaluateDesignPreviewPosition();

      campaignUpdate.addEventListener("scroll", () => this.evaluateDesignPreviewPosition());

      campaignUpdate.addEventListener("resize", () => this.evaluateDesignPreviewPosition());
    });
  },
  beforeDestroy() {
    this.$root.$off("evaluateDesignPreviewPosition");
  },
  methods: {
    evaluateDesignPreviewPosition() {
      const designWrapper = document.querySelector(".design-wrapper");
      const designPreview = document.querySelector(".design-preview");
      const designPreviewOffset = "40px";

      if (!this.source) {
        designPreview.style.left = `calc(${designWrapper.getBoundingClientRect().right}px + ${designPreviewOffset})`;
        designPreview.style.top = `${designWrapper.getBoundingClientRect().top}px`;

        if (designPreview.getBoundingClientRect().bottom > designWrapper.getBoundingClientRect().bottom)
          designPreview.style.top = "calc(100vh - 68%)";
      } else if (
        this.source &&
        this.source.includes("update") &&
        this.$route.name !== "PunchCardCreate"
      ) {
        const campaignUpdate = document.querySelector("#punch-card-campaign-update-container > .update-form-container");

        document.querySelector(".design-container").style.height = "54vh";
        designPreview.style.position = "static";
        designPreview.style.marginLeft = designPreviewOffset;

        designPreview.style.opacity = 1;

        setTimeout(() =>
          designPreview.style.marginTop = `${campaignUpdate.scrollTop - 20}px`, 300
        );

      }
    }
  }
}
</script>

<style lang="scss" scoped>
.design-container {
  min-width: 855px;
  width: 100%;
}

.design-wrapper {
  max-width: 532px;
  width: 100%;
}

.design-preview {
  width: 250px;
  font-size: 11px;
  color: #2B2F38;
  position: fixed;
  top: calc(100vh - 38%);
  transition: all 0.2s ease-in-out;

  .preview-label {
    font-family: MainFontBold, sans-serif;
    font-size: 15px;
  }
}
</style>
